// extracted by mini-css-extract-plugin
export default {"GetInTouch":"RealTimeVideo_GetInTouch__YmJMT","GetInTouchInner":"RealTimeVideo_GetInTouchInner__MBST1"};